import Vue from "vue";
import qs from "qs";

export const getMenus = () => {
  return Vue.axios.post("/api/feed/menus");
};
export const getHome = () => {
  return Vue.axios.post("/api/feed/home");
};
export const getMost = order => {
  return Vue.axios.post("/api/feed/most", qs.stringify({ order: order }));
};
// news
export const getList = (slug, maxdate) => {
  let params = { slug: slug };
  if (maxdate !== null) {
    params = { slug: slug, max_date: maxdate };
  }
  return Vue.axios.post("/api/feed/list", qs.stringify(params));
};
export const getView = newsid => {
  return Vue.axios.post("/api/feed/view", qs.stringify({ news_id: newsid }));
};
export const putComment = (newsid, comment) => {
  let params = {
    news_id: newsid,
    comment: comment
  };
  return Vue.axios.post("/api/comment/put", qs.stringify(params));
};

// search
export const getHash = hash => {
  return Vue.axios.post("/api/feed/hash", qs.stringify({ hash: hash }));
};
export const searchNews = keyword => {
  return Vue.axios.post("/api/feed/search", qs.stringify({ keyword: keyword }));
};
